import { Field, Form, Formik, FormikHelpers } from "formik";
import { useTranslation } from "react-i18next";
import { Button, Col, Container, Row } from "reactstrap";
import * as Yup from "yup";
import UnitsSelectionDropdown from "src/components/Common/UI/UnitsSelectionDropdown/UnitsSelectionDropdown";
import { useGetAllLineTypesList } from "../../Parameters/Lines/LineTypes/api/getAllLineTypesList";
import { useGetAllModemsList } from "../../Parameters/Equipment/Modems/api/getAllModemsList";
import { useGetAllAtmModelsList } from "../../Parameters/ATM/AtmModels/api/getAllAtmModelsList";
import { useGetAllAtmCompaniesList } from "../../Parameters/ATM/AtmCompanies/api/getAllAtmCompaniesList";
import { useGetAllAtmTypesList } from "../../Parameters/ATM/AtmTypes/api/getAllAtmTypesList";
import { useGetAllLineEnds } from "./api/getAllLineEnds";
import { useGetAllGpsNumbers } from "./api/getAllGpsNumbers";
import { useGetAllOteISDNNumbers } from "./api/getAllOteISDNNumbers";
import { useGetAllBackSimNumbers } from "./api/getAllBackSimNumbers";



const EditAtmForm = ({ initialValues, onSubmit, unitType }: EditAtmFormProps) => {
    const { t } = useTranslation();
    const getAllLineTypesListQuery = useGetAllLineTypesList();
    const getAllModemsListQuery = useGetAllModemsList();
    const getAllAtmModelsListQuery = useGetAllAtmModelsList();
    const getAllAtmCompaniesListQuery = useGetAllAtmCompaniesList();
    const getAllAtmTypesListQuery = useGetAllAtmTypesList();
    const useGetAllLineEndsQuery = useGetAllLineEnds({unitid: parseInt(initialValues.unitID)});
    const useGetAllGpsNumbersQuery = useGetAllGpsNumbers({unitid: parseInt(initialValues.unitID)});
    const useGetAllBackSimNumbersQuery = useGetAllBackSimNumbers({unitid: parseInt(initialValues.unitID)});
    const useGetAllOteISDNNumbersQuery = useGetAllOteISDNNumbers({unitid: parseInt(initialValues.unitID)});

    const validationSchema= Yup.object({
      description: Yup.string().required('Το πεδίο είναι υποχρεωτικό'),
      atmTerm: Yup.string().required('Το πεδίο είναι υποχρεωτικό'),
      unitID: Yup.string().required('Το πεδίο είναι υποχρεωτικό')
    })

    return (
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={(values, formikHelpers) => {
            onSubmit(values, formikHelpers);
        }}
        validationSchema={validationSchema}
      >
        {({ errors, touched, isSubmitting, values, getFieldProps }) => (
          <Form>
            <Container fluid className="p-0">
            <Row>
              <Col xs={6}>
                  <label className="form-label">
                    {`${t("Περιγραφή")}*`}
                  </label>
                  <Field
                    name="description"
                    className="form-control"
                    placeholder=""
                    type="text"
                    field="description"
                   
                  />
                  <div className="text-danger">
                    {errors.description && touched.description && (
                      <div>{errors.description}</div>
                    )}
                  </div>
                </Col>

                <Col xs={6}>
                  <label className="form-label">
                    {`${t("IP Διεύθυνση ΑΤΜ")}`}
                  </label>
                  <Field
                    name="atmAddress"
                    className="form-control"
                    placeholder=""
                    type="text"
                    field="atmAddress"
                   
                  />
                  <div className="text-danger">
                    {errors.atmAddress && touched.atmAddress && (
                      <div>{errors.atmAddress}</div>
                    )}
                  </div>
                </Col>

                <Col xs={6}>
                  <label className="form-label">
                    {`${t("ΑΤΜ Host")}`}
                  </label>
                  <Field
                    name="atmHost"
                    className="form-control"
                    placeholder=""
                    type="text"
                    field="atmHost"
                   
                  />
                  <div className="text-danger">
                    {errors.atmHost && touched.atmHost && (
                      <div>{errors.atmHost}</div>
                    )}
                  </div>
                </Col>

                <UnitsSelectionDropdown 
                  errors={errors} 
                  touched={touched} 
                  unitType={unitType}
                  requiredAsterisk={true}
                  initialUnitID={initialValues.unitID}
                />
                
                <Col xs={6}>
                  <label className="form-label">
                    {`${t("Τύπος Γραμμής")}`}
                  </label>
                  <Field
                    as="select"
                    name="lineTypeID"
                    className="form-control"
                    placeholder=""
                    type="text"
                    field="lineTypeID"
                  >
                 <option value="">{t("Επιλέξτε τύπο Γραμμής")}</option>
                  {getAllLineTypesListQuery.data &&
                    getAllLineTypesListQuery.data.map((lineType) => (
                      <option key={lineType.id} value={lineType.id}>
                        {lineType.description}
                      </option>
                    ))}
                   
                </Field>
                  <div className="text-danger">
                    {errors.lineTypeID && touched.lineTypeID && (
                      <div>{errors.lineTypeID}</div>
                    )}
                  </div>
                </Col>

                <Col xs={6} className="d-none">
                  <label className="form-label">
                    {`${t("Modem")}`}
                  </label>
                  <Field
                    as="select"
                    name="modemID"
                    className="form-control"
                    placeholder=""
                    type="text"
                    field="modemID"
                  >
                  <option value="">{t("Επιλέξτε Modem")}</option>
                    {getAllModemsListQuery.data &&
                      getAllModemsListQuery.data.map((modem) => (
                        <option key={modem.id} value={modem.id}>
                          {modem.description}
                        </option>
                      ))}
                  
                </Field>
                  <div className="text-danger">
                    {errors.modemID && touched.modemID && (
                      <div>{errors.modemID}</div>
                    )}
                  </div>
                </Col>

                <Col xs={6}>
                  <label className="form-label">
                    {`${t("Τύπος ΑΤΜ")}`}
                  </label>
                  <Field
                    as="select"
                    name="atmTypeID"
                    className="form-control"
                    placeholder=""
                    type="text"
                    field="atmTypeID"
                  >
                  <option value="">{t("Επιλέξτε Tύπο ATM")}</option>
                  {getAllAtmTypesListQuery.data &&
                    getAllAtmTypesListQuery.data.map((atmType) => (
                      <option key={atmType.id} value={atmType.id}>
                        {atmType.description}
                      </option>
                    ))}
                  
                </Field>
                  <div className="text-danger">
                    {errors.atmTypeID && touched.atmTypeID && (
                      <div>{errors.atmTypeID}</div>
                    )}
                  </div>
                </Col>

                <Col xs={6}>
                  <label className="form-label">
                    {`${t("Κωδικός ΑΤΜ")}*`}
                  </label>
                  <Field
                    name="atmTerm"
                    className="form-control"
                    placeholder=""
                    type="text"
                    field="atmTerm"
                   
                  />
                  <div className="text-danger">
                    {errors.atmTerm && touched.atmTerm && (
                      <div>{errors.atmTerm}</div>
                    )}
                  </div>
                </Col>

                <Col xs={6}>
                  <label className="form-label">
                    {`${t("Τρόπος Σύνδεσης")}`}
                  </label>
                  <Field
                    name="connMethod"
                    className="form-control"
                    placeholder=""
                    type="text"
                    field="connMethod"
                   
                  />
                  <div className="text-danger">
                    {errors.connMethod && touched.connMethod && (
                      <div>{errors.connMethod}</div>
                    )}
                  </div>
                </Col>

                <Col xs={6} className="d-none">
                  <label className="form-label">
                    {`${t("Επαφή")}`}
                  </label>
                  <Field
                    name="contact"
                    className="form-control"
                    placeholder=""
                    type="text"
                    field="contact"
                   
                  />
                  <div className="text-danger">
                    {errors.contact && touched.contact && (
                      <div>{errors.contact}</div>
                    )}
                  </div>
                </Col>

                <Col xs={6} className="d-none">
                  <label className="form-label">
                    {`${t("Μοντέλο ΑΤΜ")}`}
                  </label>
                  <Field
                    as="select"
                    name="atmModelID"
                    className="form-control"
                    placeholder=""
                    type="text"
                    field="atmModelID"
                  >
                  <option value="">{t("Επιλέξτε Μοντέλο ΑΤΜ")}</option>
                  {getAllAtmModelsListQuery.data &&
                    getAllAtmModelsListQuery.data.map((atmModel) => (
                      <option key={atmModel.id} value={atmModel.id}>
                        {atmModel.description}
                      </option>
                    ))}
                  
                </Field>
                  <div className="text-danger">
                    {errors.atmModelID && touched.atmModelID && (
                      <div>{errors.atmModelID}</div>
                    )}
                  </div>
                </Col>

                <Col xs={6} className="d-none">
                  <label className="form-label">
                    {`${t("Εταιρία ΑΤΜ")}`}
                  </label>
                  <Field
                    as="select"
                    name="atmCompany"
                    className="form-control"
                    placeholder=""
                    type="text"
                    field="atmCompany"
                  >
                  <option value="">{t("Επιλέξτε Εταιρία ΑΤΜ")}</option>
                  {getAllAtmCompaniesListQuery.data &&
                    getAllAtmCompaniesListQuery.data.map((atmCompany) => (
                      <option key={atmCompany.id} value={atmCompany.id}>
                        {atmCompany.description}
                      </option>
                    ))}
                  
                </Field>
                  <div className="text-danger">
                    {errors.atmCompany && touched.atmCompany && (
                      <div>{errors.atmCompany}</div>
                    )}
                  </div>
                </Col>

                <Col xs={6} className="d-none">
                  <label className="form-label">
                    {`${t("Εμπορική")}`}
                  </label>
                  <Field
                    type="checkbox"
                    name="isEmporiki"
                    field="isEmporiki"
                  />
                  <div className="text-danger">
                    {errors.isEmporiki && touched.isEmporiki && (
                      <div>{errors.isEmporiki}</div>
                    )}
                  </div>
                </Col>

                <Col xs={6} className="d-none">
                  <label className="form-label">
                    {`${t("Citibank")}`}
                  </label>
                  <Field
                    type="checkbox"
                    name="isCiti"
                    field="isCiti"
                  />
                  <div className="text-danger">
                    {errors.isCiti && touched.isCiti && (
                      <div>{errors.isCiti}</div>
                    )}
                  </div>
                </Col>

                <Col xs={6}>
                <label className="form-label">
                  {`${t("Ταχ. Διεύθυνση")}`}
                </label>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Field
                    name="physicalAddress"
                    className="form-control"
                    placeholder=""
                    type="text"
                    field="physicalAddress"
                    disabled
                  /> 
                </div>
              </Col>

              <Col xs={6}>
                  <label className="form-label">
                    {`${t("Άκρο Γραμμής")}`}
                  </label>
                  <Field
                    as="select"
                    name="lineEndID"
                    className="form-control"
                    placeholder=""
                    type="text"
                    field="lineEndID"
                  >
                  <option value="">{t("Επιλέξτε Άκρο Γραμμής")}</option>
                  {useGetAllLineEndsQuery.data &&
                    useGetAllLineEndsQuery.data.map((lineEnd) => (
                      <option key={lineEnd.id} value={lineEnd.id}>
                        {lineEnd.label}
                      </option>
                    ))}
                  
                </Field>
                  <div className="text-danger">
                    {errors.lineEndID && touched.lineEndID && (
                      <div>{errors.lineEndID}</div>
                    )}
                  </div>
                </Col>

{/*                 <Col xs={6}>
                  <label className="form-label">
                    {`${t("GPS Number")}`}
                  </label>
                  <Field
                    as="select"
                    name="gpsid"
                    className="form-control"
                    placeholder=""
                    type="text"
                    field="gpsid"
                  >
                  <option value="">{t("Επιλέξτε GPS Number")}</option>
                  {useGetAllGpsNumbersQuery.data &&
                    useGetAllGpsNumbersQuery.data.map((gps) => (
                      <option key={gps.id} value={gps.id}>
                        {gps.phoneNumber}
                      </option>
                    ))}
                  
                </Field>
                  <div className="text-danger">
                    {errors.gpsid && touched.gpsid && (
                      <div>{errors.gpsid}</div>
                    )}
                  </div>
                </Col>

                <Col xs={6}>
                  <label className="form-label">
                    {`${t("OTE ISDN Number")}`}
                  </label>
                  <Field
                    as="select"
                    name="isdnid"
                    className="form-control"
                    placeholder=""
                    type="text"
                    field="isdnid"
                  >
                  <option value="">{t("Επιλέξτε OTE ISDN Number")}</option>
                  {useGetAllOteISDNNumbersQuery.data &&
                    useGetAllOteISDNNumbersQuery.data.map((ote) => (
                      <option key={ote.id} value={ote.id}>
                        {ote.phoneNumber}
                      </option>
                    ))}
                  
                </Field>
                  <div className="text-danger">
                    {errors.isdnid && touched.isdnid && (
                      <div>{errors.isdnid}</div>
                    )}
                  </div>
                </Col>

                <Col xs={6}>
                  <label className="form-label">
                    {`${t("Back Sim Number")}`}
                  </label>
                  <Field
                    as="select"
                    name="bsimid"
                    className="form-control"
                    placeholder=""
                    type="text"
                    field="bsimid"
                  >
                  <option value="">{t("Επιλέξτε Back Sim Number")}</option>
                  {useGetAllBackSimNumbersQuery.data &&
                    useGetAllBackSimNumbersQuery.data.map((backSim) => (
                      <option key={backSim.id} value={backSim.id}>
                        {backSim.phoneNumber}
                      </option>
                    ))}
                  
                </Field>
                  <div className="text-danger">
                    {errors.bsimid && touched.bsimid && (
                      <div>{errors.bsimid}</div>
                    )}
                  </div>
                </Col>

                <Col xs={6} >
                  <label className="form-label">
                    {`${t("Little Box Serial")}`}
                  </label>
                  <Field
                    name="littleBoxSerial"
                    className="form-control"
                    placeholder=""
                    type="text"
                    field="littleBoxSerial"
                   
                  />
                  <div className="text-danger">
                    {errors.littleBoxSerial && touched.littleBoxSerial && (
                      <div>{errors.littleBoxSerial}</div>
                    )}
                  </div>
                </Col> */} 

                <Col xs={6}>
                <label className="form-label">
                  {t("Σχόλια")}
                </label>
                <Field
                  type="text"
                  name="comments"
                  field="comments"
                  className="form-control"
                  as="textarea"
                />
                <div className="text-danger">
                  {errors.comments && touched.comments && (
                    <div>{errors.comments}</div>
                  )}
                </div>
              </Col>
            
              </Row>
            </Container>

            <div className="mb-3">
              <Button
                type="submit"
                size="sm"
                styletype="primary"
                disabled={isSubmitting}
              >
                {t("Αποθήκευση")}
              </Button>
            </div>
          </Form>
      )}
      </Formik>
  )
}

export default EditAtmForm;

type EditAtmFormProps =
   {
      unitType:string | undefined;
      initialValues: IEditAtmForm;
      onSubmit: (
        values: IEditAtmForm,
        formikHelpers: FormikHelpers<IEditAtmForm>
      ) => void;
    }